<div mat-dialog-title>{{ "protocol.share.by-email.title" | translate }}</div>
<div
	mat-dialog-content
	[formGroup]="formGroup">
	<div class="flex flex-col gap-y-4">
		<p>{{ "protocol.share.by-email.description" | translate }}</p>
		<mat-form-field
			appearance="outline"
			class="w-full">
			<mat-label>{{ "protocol.share.by-email.email" | translate }}</mat-label>
			<input
				formControlName="email"
				matInput
				type="text" />
			<mat-error>{{ "core.input.email.error" | translate }}</mat-error>
			<mat-icon matIconPrefix>email</mat-icon>
		</mat-form-field>
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.close" | translate }}
	</button>
	@if (isLoading) {
		<mat-spinner diameter="40" />
	}
	@if (!isLoading) {
		<button
			mat-raised-button
			color="primary"
			[disabled]="!formGroup.valid"
			(click)="apply()">
			{{ "core.share" | translate }}
		</button>
	}
</div>
